import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

/**
 * Servicio global para manejo centralizado de errores
 * Captura tanto errores de Angular como errores HTTP
 */
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse): void {
    const router = this.injector.get(Router);
    
    if (error instanceof HttpErrorResponse) {
      // Error HTTP (del servidor o de red)
      this.handleHttpError(error, router);
    } else {
      // Error del lado del cliente (JavaScript)
      this.handleClientError(error);
    }
  }

  /**
   * Maneja errores HTTP
   */
  private handleHttpError(error: HttpErrorResponse, router: Router): void {
    if (!navigator.onLine) {
      // Sin conexión a internet
      this.logError('No hay conexión a internet', error);
    } else {
      // Error del servidor
      const message = error.error?.message || error.message || 'Error del servidor';
      this.logError(`Error HTTP ${error.status}: ${message}`, error);
      
      // Redireccionar en casos específicos
      if (error.status === 404) {
        // Podría redirigir a página 404
      }
    }
  }

  /**
   * Maneja errores del cliente
   */
  private handleClientError(error: Error): void {
    this.logError(`Error del cliente: ${error.message}`, error);
  }

  /**
   * Registra el error en consola o servicio externo
   */
  private logError(message: string, error: any): void {
    if (environment.production) {
      // En producción: enviar a servicio de logging externo
      // Ejemplos: Sentry, LogRocket, Rollbar, etc.
      // this.sentryService.captureException(error);
      console.error(message); // Temporal, reemplazar con servicio real
    } else {
      // En desarrollo: mostrar en consola con detalles
      console.error('=== ERROR CAPTURADO ===');
      console.error('Mensaje:', message);
      console.error('Stack:', error.stack || error);
      console.error('=======================');
    }
  }
}





